import React from 'react'
import styled from 'styled-components'

const Checkbox = ({disabled, onChange, checked, children, position = 'left', className = '',
                    checkboxClassName, labelClassName }) => {
  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(!checked)
    }
  }
  return (
    <Styled
      className= { className + ' checkbox' }
      onClick={ handleClick }
    >
      { position === 'left' && children }
      <input
        type="checkbox"
        className={ checkboxClassName }
        checked={ checked }
        disabled={disabled}
        onChange={ handleClick }
      />
      <label className={ labelClassName }/>
      { position === 'right' && children }
    </Styled>
  )
}

export default Checkbox

const Styled = styled.div`

  display: flex;
  font-size: 14px;
  line-height: 14px;
  
  > input {
    opacity: 0;
  }
  > span{
      font-weight: bold;
  }
  
  > input + label {
    position: relative; /* permet de positionner les pseudo-éléments */
    padding-left: 25px; /* fait un peu d'espace pour notre case à venir */
    cursor: pointer;    /* affiche un curseur adapté */
    &:before {
      content: '';
      position: absolute;
      left:0; top: 1px;
      width: 12px; height: 12px; /* dim. de la case */
      border: 1px solid #14489f;
      border-radius: 3px; /* angles arrondis */
      box-shadow: inset 0 1px 3px rgba(0,0,0,.3) /* légère ombre interne */
    }
    &:after {
      content: '✔';
      position: absolute;
      top: -1px; left: 2px;
      font-size: 16px;
      color: #14489f;
      transition: all .2s; /* on prévoit une animation */
    }
  }
  > input:not(:checked) + label {
      &:after {
        opacity: 0; /* coche invisible */
        transform: scale(0); /* mise à l'échelle à 0 */
      }
  }
  > input:disabled:not(:checked) + label {
      &:before {
        box-shadow: none;
        border-color: #bbb;
        background-color: #ddd;
      }
  }
  > input:checked + label {
    &:after {
      opacity: 1; /* coche opaque */
      transform: scale(1); /* mise à l'échelle 1:1 */
    }
  }
  > input:disabled:checked + label {
    &:after {
      color: #999;
    }
  }
  > input:disabled + label {
    color: #aaa;
  }
  > input:checked:focus + label, input:not(:checked):focus + label {
    &:before {
      border: 1px dotted blue;
    }
  }
  
    
`
